import type {
  InterventionTemplateSelectProps,
  InterventionTemplateSelectOptionItemData,
  InterventionTemplateSelectOptionItemValue,
} from "./intervention-template-select.type";

import { useTranslation } from "react-i18next";

import { INTERVENTION_TEMPLATES_FILTERS } from "@/entities/intervention-templates";
import QueryableSelect from "@/modules/queryable-select";

import { InterventionTemplateSelectOption } from "./intervention-template-select-option";
import { formatInterventionTemplateSelectValue } from "./intervention-template-select.helper";

export const InterventionTemplateSelect = ({
  name = "template",
  label,
  placeholder,
  hideLabel,
  ...props
}: InterventionTemplateSelectProps) => {
  const { t } = useTranslation();
  const resolvedLabel = label || t("organization:form.defaultTemplate.label");

  return (
    <QueryableSelect<
      InterventionTemplateSelectOptionItemValue,
      InterventionTemplateSelectOptionItemData
    >
      model="interventionTemplates"
      tableName="intervention_templates"
      filterBy="name"
      optionFormat={InterventionTemplateSelectOption}
      optionLabelProp="children"
      name={name}
      formatFieldValue={formatInterventionTemplateSelectValue}
      label={hideLabel ? undefined : resolvedLabel}
      placeholder={placeholder || resolvedLabel}
      additionalFilters={{
        [INTERVENTION_TEMPLATES_FILTERS.ASSOCIABLE]: "true",
      }}
      dropdownRenderOptions={{ multilineOptions: 2 }}
      styles={{ popup: { root: { minWidth: 500 } } }}
      {...props}
    />
  );
};
